function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  xmlns: "http://www.w3.org/2000/svg",
  "data-original": "#000000",
  d: "M368.713 345.606L347.5 324.394l-94.394 94.393V0h-30v418.787l-94.393-94.393-21.213 21.212 130.607 130.607z"
});

function SvgIconArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 476.213 476.213",
    className: " w-full h-full fill-current"
  }, props), _ref);
}

export default SvgIconArrow;